import { render } from "./TopCategories.vue?vue&type=template&id=2a9e4db8"
import script from "./TopCategories.vue?vue&type=script&lang=js"
export * from "./TopCategories.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__